import { Injectable } from '@angular/core';

import { activityFavoritesRemoveFavorite, activityFavoritesSetFavorite } from '@api/sdk.gen';

@Injectable({ providedIn: 'root' })
export class ActivityFavoritesApiService {
  setFavorite(activityId: string): Promise<void> {
    return activityFavoritesSetFavorite({
      path: { activityId },
      throwOnError: true,
      responseStyle: 'data' as const,
    }).then(() => undefined);
  }

  removeFavorite(activityId: string): Promise<void> {
    return activityFavoritesRemoveFavorite({
      path: { activityId },
      throwOnError: true,
      responseStyle: 'data' as const,
    }).then(() => undefined);
  }
}
